import { IBuildingStackSyncSettings } from '@llws/lift-entity-interfaces';
import app from '@/main';

export const getNewBuildingStackSyncSettings = (): Partial<IBuildingStackSyncSettings> => ({
  id: null,
  clientId: Number(app()?.$rsGlobals.$currentClient?.id),
  lastSyncStatus: 'unknown',
  intervalHours: 24,
  statusOnBuildingInsert: 'disabled',
  statusOnBuildingDelete: 'no-action',
  statusOnSuiteTypeInsert: 'enabled',
  onSuiteTypeDelete: 'unavailable',
  onSuiteTypeResync: 'no-action',
  syncOnLink: 0,
  updateBuildingAmentiesFromUnitAmenities: 0,
  allowRsBuildingCreate: 1,
  allowRsSuiteTypeCreate: 1,
  allowRsBuildingCreateUi: 1,
  allowRsSuiteTypeCreateUi: 1,
  suiteTypeRentsyncStatusEditable: 1,
  suiteTypeRentsyncAvailableEditable: 1,
  status: 'disabled',
  createdUserId: Number(app()?.$rsGlobals.$currentUser.userId!),
});
